import {Action} from "@ngrx/store";

export const TOGGLE_WEBSITE_SIDEBAR: string = '[WebsiteSidebar] Toggle Website Sidebar';

export class ToggleWebsiteSidebar implements Action {

  readonly type: string = TOGGLE_WEBSITE_SIDEBAR;

}

export type WebsiteSidebarAction = ToggleWebsiteSidebar;
